const ChevronDownIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.2611 8.23495C4.42784 8.08454 4.65423 8.00001 4.89033 8.00001C5.12642 8.00001 5.35282 8.08454 5.51955 8.23495L12.0002 14.0681L18.4809 8.23495C18.8284 7.92225 19.3919 7.92225 19.7394 8.23495C20.0869 8.54766 20.0869 9.05465 19.7394 9.36735L12.6295 15.7651C12.4627 15.9155 12.2363 16 12.0002 16C11.7641 16 11.5377 15.9155 11.371 15.7651L4.2611 9.36735C4.09394 9.21732 4 9.0136 4 8.80115C4 8.5887 4.09394 8.38499 4.2611 8.23495Z"
      fill="#4B4F54"
    />
  </svg>
);

export default ChevronDownIcon;
